export const GET_MAIN_SHAFT_BEARING_RESULT = "GET_MAIN_SHAFT_BEARING_RESULT";
export const GET_MAIN_SHAFT_UPWINDBEARING_RESULT = "GET_MAIN_SHAFT_UPWINDBEARING_RESULT";
export const GET_MAIN_SHAFT_DOWNWINDBEARING_RESULT = "GET_MAIN_SHAFT_DOWNWINDBEARING_RESULT";
export const GET_MAIN_SHAFT_BEARING_SUCCESS = "GET_MAIN_SHAFT_BEARING_SUCCESS";
export const GET_MAIN_SHAFT_UPWINDBEARING_SUCCESS = "GET_MAIN_SHAFT_UPWINDBEARING_SUCCESS";
export const GET_MAIN_SHAFT_DOWNWINDBEARING_SUCCESS = "GET_MAIN_SHAFT_DOWNWINDBEARING_SUCCESS";
export const GET_MAIN_BEARING_RESULT_ERROR = "GET_MAIN_BEARING_RESULT_ERROR";
export const RESET_MAIN_BEARING_RESULT = "RESET_MAIN_BEARING_RESULT";
